import { searchApprovals } from '@lib/api'
import { approvalKeys } from '@lib/keys'
import { useQuery } from '@tanstack/react-query'

export const useApprovals = (start: DateTime, end: DateTime) => {
  return useQuery(approvalKeys.search(start, end), () =>
    searchApprovals(start, end),
  )
}
